module.exports = __webpack_public_path__ + "static/media/adminIcon04.e5e0db32.svg";